import { createGlobalStyle } from 'styled-components'

export default createGlobalStyle`
  :root {
    --background-gray: #fafafa;
    --border-gray: #e5e7eb;
    --dark-gray: #9d9d9c;
    --dark-red: #a52016;
    --disabled: #f0f0f0;
    --edu-color-neutral-400: #BFBFBF;
    --grade-Green1: #b2c92a;
    --grade-Green2: #96be2d;
    --grade-Green3: #76b331;
    --grade-Green4: #4ea829;
    --grade-Hover: #ecedf1;
    --grade-LightGreen1: #f0f4d4;
    --grade-LightGreen2: #eaf2d5;
    --grade-LightGreen3: #e4f0d6;
    --grade-LightGreen4: #dceed4;
    --grade-LightRed: #f9d0d2;
    --grade-Red: #e0121e;
    --green-border: #009640;
    --infoGrey: #777778;
    --menu-gray: #706f6f;
    --orange: #f6b019;
    --red-message: #e20613;
    --silver: #c6c6c6;
    --soft-gray: #f2f2f2;
    --text-gray: #444;
    --white: #fff;
  }
`
